<template>
    <div class="main-panel-inventario">
        <nav class="navbar navbar-default">
            <div class="container-fluid">
                <div class="navbar-header">
                    <a class="navbar-brand" href="#">
                        <img alt="Brand" src="static/img/logo_completo.png">
                    </a>
                </div>
            </div>
        </nav>
        <div class="content">
            <div class="container-fluid">
                <div v-if="!inventarioFinalizado" style="margin: 10px" class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <h3 class="tituloNumier"> {{$t('inventario')}}</h3>
                                    <p><strong>TPV:</strong> {{datosInventario.nameShow}}</p>
                                    <p><strong>{{$t('fecha')}}:</strong> {{datosInventario.date | parseDate}}</p>
                                </div>
                            </div>
                            <!-- Materias primas con código ambiguo: la API las devuelve aparte y no se contabilizan -->
                            <div v-if="listExcluidos.length" class="col-md-12">
                                <div class="alert alert-warning inventario-excluidos" role="alert">
                                    <p class="inventario-excluidos-titulo">
                                        <i class="fas fa-exclamation-triangle"></i>
                                        <strong>{{$t('inventarioExcluidosTitulo')}}</strong>
                                    </p>
                                    <p>{{$t('inventarioExcluidosTexto')}}</p>
                                    <ul>
                                        <li v-for="xExcluido in listExcluidos" :key="xExcluido.codeSubproduct">
                                            <strong>{{nombresExcluido(xExcluido)}}</strong>
                                            <ul>
                                                <li v-for="xMotivo in xExcluido.motivos" :key="xMotivo.codigo">
                                                    {{textoMotivo(xExcluido, xMotivo)}}
                                                    <span v-if="xMotivo.codigo === 'LINEA_DUPLICADA'" class="inventario-excluidos-lineas">
                                                        <span v-for="xLinea in xExcluido.lineas" :key="xLinea.id">
                                                            (Escandallo: {{xLinea.escandallo}} - {{$t('partes')}}: {{xLinea.partes}})
                                                        </span>
                                                    </span>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="row">
                                        <div class="col-md-6" style="margin-bottom: 10px">
                                            <input @keyup.enter.prevent="searchInventario()" v-model="search"
                                                   placeholder="Busca por codigo de barras o nombre"
                                                   class="form-control"></input>
                                        </div>
                                        <div class="col-md-6">
                                            <button class="btn btn-primary" @click="searchInventario"><i
                                                    class="fas fa-search"></i> {{$t('buscarSinPuntos')}}
                                            </button>
                                        </div>
                                        <div class="col-md-12">
                                            <button class="btn btn-success" style="width: 100%" v-once-click="saveInventario">
                                                <i class="fas fa-check"></i> {{$t('enviarInventario')}}
                                            </button>
                                        </div>

                                        <div class="col-md-12">
                                            <el-collapse v-model="activeNames" @change="handleChange">
                                                <el-collapse-item style="color: white; border-bottom: 1px solid #004050"
                                                                  v-for="xCat in listCategories"
                                                                  :key="xCat.idTag"
                                                                  :title="xCat.nameCatego">
                                                    <div class="table-responsive">
                                                        <table style="background: white"
                                                               class="table table-bordered table-striped">
                                                            <thead>
                                                            <tr style="background:  #004050">
                                                                <th>{{$t('nombre')}}</th>
                                                                <th>{{$t('unidades')}}</th>
                                                                <th>{{$t('partes')}}</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr v-for="xMateriaPrima in xCat.listSubproducts">
                                                                <td>{{xMateriaPrima.nombreSubproduct}}
                                                                    <br>
                                                                    <span style="font-size:0.9em; color: #757272">({{xMateriaPrima.type}} - Escandallo: {{xMateriaPrima.escandallo}})</span>
                                                                </td>
                                                                <td><input @change="changeDetails(xMateriaPrima)"
                                                                           class="form-control" type="number"
                                                                           placeholder="0" min="0"
                                                                           v-model="xMateriaPrima.unidadesSubproduct"></input>
                                                                </td>
                                                                <td><input @change="changeDetails(xMateriaPrima)"
                                                                           :disabled="xMateriaPrima.escandallo<=1"
                                                                           placeholder="0" class="form-control"
                                                                           type="number" min="0"
                                                                           v-model="xMateriaPrima.partesSubproduct"></input>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                </el-collapse-item>
                                            </el-collapse>


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div v-else class="row" style="text-align:center">
                    <div class="col-md-12">
                        <h2><i :class="getIcono" style="font-size: 2em;"></i><br>
                            {{getTexto}}</h2>

                        <router-link
                                :to="{name:'historial-almacen'}">
                        <button class="btn btn-primary">{{$t('volverAlAlmacen')}}</button>
                        </router-link>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Collapse, CollapseItem} from 'element-ui';
    import swal from 'sweetalert2';
    import {Loading} from 'element-ui';

    export default {
        name: 'Inventario',
        data() {
            return {

                hash: this.$route.params.query,
                idTpv: 0,
                complete: 0,
                activeNames: [],
                search: "",
                listCategories: [],
                listCategoriesAll: [],
                listExcluidos: [],
                loading: null,
                inventarioFinalizado: false,

                datosInventario:false,

            }
        },
        computed: {

            getTexto() {
                switch (this.inventarioFinalizado) {
                    case 1:
                        return this.$t('inventarioCompletado');
                    case 2:
                        return this.$t('inventarioNoEncontrado');
                }

            },
            getIcono() {

                switch (this.inventarioFinalizado) {

                    case 1:
                        return "fas fa-check-circle text-success";
                    case 2:
                        return "fas fa-times-circle text-danger"
                }
            },


        },
        methods: {

            handleChange(val) {

            },

            nombresExcluido(excluido) {
                return excluido.subproductos.map(function (sub) {
                    return sub.nombreSubproduct + ' (' + sub.nameCatego + ')';
                }).join(' / ');
            },

            textoMotivo(excluido, motivo) {
                switch (motivo.codigo) {
                    case 'CODIGO_COMPARTIDO':
                        return this.$t('inventarioExcluidoCodigoCompartido', {
                            codigo: excluido.codeSubproduct,
                            total: excluido.subproductos.length
                        });
                    case 'LINEA_DUPLICADA':
                        return this.$t('inventarioExcluidoLineaDuplicada', {
                            codigo: excluido.codeSubproduct,
                            total: excluido.lineas.length
                        });
                    default:
                        return motivo.mensaje;
                }
            },

            getInventario() {
                var config = {
                    params: {
                        hash: this.hash,
                    }
                };
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'almacen/getInventarioOnline', config)
                    .then(function (response) {
                        if (response.data.response) {

                            //INVENTARIO TERMINADO
                            if (response.data.result.datosInventario.finalizado) {
                                vm.inventarioFinalizado = 1;
                            }

                            vm.loading.close();

                            vm.datosInventario=response.data.result.datosInventario;
                            vm.listCategories = response.data.result.listCategorias;
                            vm.listCategoriesAll = response.data.result.listCategorias;
                            vm.listExcluidos = response.data.result.listExcluidos || [];
                            vm.idTpv = response.data.result.datosInventario.idTpv;

                        } else {

                            //INVENTARIO NO ENCONTRADO
                            vm.inventarioFinalizado = 2;


                            vm.loading.close();
                        }

                    });

            },

            searchInventario() {

                this.listCategories = [];

                for (let i = 0; i < this.listCategoriesAll.length; i++) {

                    let productList = [];
                    let existe = false;

                    for (let z = 0; z < this.listCategoriesAll[i].listSubproducts.length; z++) {

                        if (this.listCategoriesAll[i].listSubproducts[z].nombreSubproduct.toUpperCase().indexOf(this.search.toUpperCase()) !== -1 || this.listCategoriesAll[i].listSubproducts[z].codigoBarras.toUpperCase().indexOf(this.search.toUpperCase()) !== -1) {

                            productList.push(this.listCategoriesAll[i].listSubproducts[z]);
                            existe = true;
                        }
                    }

                    if (existe) {

                        let category = {
                            idTag: this.listCategoriesAll[i].idTag,
                            nameCatego: this.listCategoriesAll[i].nameCatego,
                            listSubproducts: productList
                        }

                        this.listCategories.push(category);

                        this.activeNames.push(this.listCategoriesAll[i].idTag);

                    }
                }
            },

            changeDetails(det) {

                var params = {
                    det: det,
                };

                let vm = this;
                let controller = "saveDetInventario";
                this.axios.post(this.$store.getters.apiUrl + 'almacen/' + controller, params)
                    .then(function (response) {

                        if (response.data.response) {


                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                });

            },

            saveInventario() {

                var params = {
                    listCategories: this.listCategoriesAll,
                    hash: this.hash,
                    idTpv: this.idTpv,
                };

                let vm = this;
                let controller = "saveInventario";
                this.axios.post(this.$store.getters.apiUrl + 'almacen/' + controller, params)
                    .then(function (response) {

                        if (response.data.response) {

                            vm.inventarioFinalizado = 1;

                        }
                    }).catch(function (error) {
                    console.log(error);
                });

            },

        },
        created() {

            this.getInventario();
            this.loading = Loading.service({text: this.$t('cargandoInventario')});

        },
        components: {
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem
        },
    }
</script>

<style scoped>

    .navbar-default {
        background-color: #004050;
        border-color: #004050;
    }

    .main-panel-inventario {
        background: rgba(203, 203, 210, 0.15);
        position: relative;
        float: right;
        width: 100%;
    }

    .main-panel-inventario .content {
        min-height: 100vh;
    }

    .table > thead > tr > th, .el-table__body > thead > tr > th {
        color: white;
    }

    .card {
        padding: 20px;
    }

    .inventario-excluidos ul {
        margin-bottom: 0;
    }

    .inventario-excluidos-titulo {
        font-size: 1.1em;
    }

    .inventario-excluidos-lineas {
        color: #6d5a1f;
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/GestionAlmacen/Inventario.vue